(() => {
  'use strict';
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const hover = matchMedia('(hover: hover) and (pointer: fine)');
  const stacks = new Map();
  function init(scope = document) {
    scope.querySelectorAll('[data-flash-stack]').forEach(stack => {
      if (stacks.has(stack)) return;
      const frames = [...stack.querySelectorAll('[data-flash-frame]')];
      const stage = stack.querySelector('[data-flash-stage]');
      if (frames.length < 2 || !stage) return;
      const controller = new AbortController();
      const options = { signal: controller.signal };
      const interval = Math.max(150, Number(stack.dataset.interval) || 200);
      const angle = Math.min(12, Math.max(0, Number(stack.dataset.angle) || 0));
      let index = 0, timer = 0, active = false, queue = [], firstRound = true;
      const show = next => {
        const image = frames[next].querySelector('img');
        if (!image?.complete || image.naturalWidth === 0) return;
        frames[index].classList.remove('is-current');
        index = next;
        frames[index].style.setProperty('--frame-angle', `${reduced.matches ? 0 : ((Math.random() * 2 - 1) * angle).toFixed(2)}deg`);
        frames[index].classList.add('is-current');
      };
      const advance = () => {
        if (!queue.length) {
          queue = frames.map((frame, next) => ({ next, image: frame.querySelector('img') }))
            .filter(({ next, image }) => image?.complete && image.naturalWidth > 0 && (!firstRound || next !== index))
            .map(({ next }) => next);
          firstRound = false;
          for (let i = queue.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [queue[i], queue[j]] = [queue[j], queue[i]];
          }
          if (queue.length > 1 && queue[0] === index) [queue[0], queue[1]] = [queue[1], queue[0]];
        }
        const next = queue.shift();
        if (next !== undefined && next !== index) show(next);
      };
      const stop = () => { active = false; clearTimeout(timer); timer = 0; };
      const tick = () => {
        if (!active || !stack.isConnected || document.hidden || reduced.matches) { stop(); return; }
        advance();
        timer = setTimeout(tick, stack.dataset.motion === 'low' ? Math.max(800, interval) : interval);
      };
      const start = event => {
        if (event.pointerType === 'touch' || !hover.matches || reduced.matches || stack.dataset.motion === 'off' || active) return;
        queue = [];
        firstRound = true;
        active = true;
        tick();
      };
      stage.addEventListener('pointerenter', start, options);
      stage.addEventListener('pointerleave', stop, options);
      stage.addEventListener('click', stop, options);
      stage.addEventListener('blur', stop, options);
      window.addEventListener('blur', stop, options);
      document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); }, options);
      reduced.addEventListener('change', () => { stop(); if (reduced.matches) frames.forEach(frame => frame.style.removeProperty('--frame-angle')); }, options);
      hover.addEventListener('change', stop, options);
      frames.forEach(frame => frame.style.setProperty('--frame-angle', `${reduced.matches ? 0 : ((Math.random() * 2 - 1) * angle).toFixed(2)}deg`));
      stacks.set(stack, () => { stop(); controller.abort(); });
    });
  }
  const previewState = new WeakMap();
  function preview(option) {
    const section = option.closest('[data-product-section]');
    const target = section?.querySelector(`[data-colour-image][data-media-id="${CSS.escape(option.dataset.colourPreview)}"]`);
    if (!target) return;
    if (!previewState.has(section)) previewState.set(section, [...section.querySelectorAll('[data-colour-image]')].map(media => [media, media.hidden]));
    section.querySelectorAll('[data-colour-image]').forEach(media => { media.hidden = media !== target; });
  }
  function restore(option) {
    const section = option.closest('[data-product-section]');
    const state = previewState.get(section);
    state?.forEach(([media, hidden]) => { media.hidden = hidden; });
    if (section) previewState.delete(section);
  }
  document.addEventListener('pointerover', event => {
    const option = event.target.closest('[data-colour-preview]');
    if (option && hover.matches && event.pointerType !== 'touch' && !option.contains(event.relatedTarget)) preview(option);
  });
  document.addEventListener('pointerout', event => {
    const option = event.target.closest('[data-colour-preview]');
    if (option && !option.contains(event.relatedTarget)) restore(option);
  });
  document.addEventListener('focusin', event => { const option = event.target.closest('[data-colour-preview]'); if (option) preview(option); });
  document.addEventListener('focusout', event => { const option = event.target.closest('[data-colour-preview]'); if (option) restore(option); });
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    for (const [stack, cleanup] of stacks) if (event.target.contains(stack)) { cleanup(); stacks.delete(stack); }
  });
  init();
})();
